const en = {
  i18n: {
    login: 'Login',
    account: 'Account',
    connectWallet: 'Connect Wallet',
    designBy: 'Design by',
    price: 'Price',
    totalMinted: 'Total Minted',
    endTime: 'End Time',
    mint: 'Mint',
    ended: 'Ended',
    view: 'View',
    tips: '*All information is for reference only. Transit does not make any investment advice. NFTs in this event follow the ',
    cc0: 'CC0 protocol',
    searchName: 'Search name or id',
    submitted: 'Submitted',
    success: 'Success',
    guide: 'User Guide',
    copied: 'Copied',
    contract: 'Contract'
  }
};

export default en;